import { render, staticRenderFns } from "./edit-password.vue?vue&type=template&id=38a5afa7"
import script from "./edit-password.vue?vue&type=script&lang=ts"
export * from "./edit-password.vue?vue&type=script&lang=ts"
import style0 from "./edit-password.vue?vue&type=style&index=0&id=38a5afa7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports